import React from 'react';
import { Navigate } from 'react-router-dom';
import AdminLayout from 'components/Layout/Admin';
import Admin from 'views/Admin';
import Users from 'views/Admin/Users';
import Companies from 'views/Admin/Companies';
import Financial from 'views/Admin/Financial';
import AdminFluxAbout from 'views/Admin/Flux/About';
import AdminWindxModels from 'views/Admin/Windx/Models';
import mailerRouter from './MailerRouter';

const adminRouter = {
  path: 'admin',
  element: <AdminLayout />,
  children: [
    { path: '', element: <Admin /> },
    { path: 'users', element: <Users /> },
    { path: 'companies', element: <Companies /> },
    { path: 'financial', element: <Financial /> },
    { path: 'flux', element: <Navigate to="/admin/flux/about" replace /> },
    { path: 'flux/about', element: <AdminFluxAbout /> },
    { path: 'windx', element: <Navigate to="/admin/windx/models" replace /> },
    { path: 'windx/models', element: <AdminWindxModels /> },
    mailerRouter,
  ],
};

export default adminRouter;
